<template>
  <div class="container-fluid">
    <loading :active.sync="loading"
             :loader="'dots'"
             :color="'#58f0ac'"
             :width="128"
             :background-color="'#000'"
             :opacity="0.75"
             :can-cancel="false"
             :is-full-page="true"></loading>
  </div>
</template>
<script>

  export default {
    data() {
      return {
        token: "",
        loading: true,
      }
    },
    mounted() {
      this.loading = true;
      let token = this.$route.params.token
      localStorage.setItem("user_jwt", token)
      this.loading = false;
      this.$router.push("/")
    }
  }
</script>
<style>
</style>
